export default __webpack_public_path__ + "static/media/emissaryofelysium.e6fa4278.png";